import * as React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { updateCompanyFollowers } from '@company/features/action.company';
import IFollowCompany, { ITeamMember, TFollowCompany } from './IFollowCompany';
import { TReducers } from '@features/reducers';
import ToolTip from '@appComponents/ToolTip/ToolTip';

import * as style from './FollowCompanyStyle.module.scss'

let componentRef: FollowCompany | null = null;
export class FollowCompany extends React.Component<IFollowCompany, TFollowCompany> {
  cancelToken = axios.CancelToken;
  source = this.cancelToken.source();
  state: TFollowCompany = { follow: null, followers: this.props.followers };

  componentDidMount() {
    componentRef = this;

    if (this.props.userSignedIn) {
      this.updateFollowStatus();
    }
  }

  componentWillUnmount() {
    this.source.cancel();
  }

  btnOnClick = () => {
    if (!this.state.follow) {
      axios.post(`/api/companies/${this.props.companyId}/following`)
        .then((res) => {
          this.props.dispatch(updateCompanyFollowers(this.state.followers + 1));
          this.setState({ follow: !this.state.follow, followers: this.state.followers + 1 });
        });
    } else {
      axios.delete(`/api/companies/${this.props.companyId}/following`)
      .then((res) => {
        this.props.dispatch(updateCompanyFollowers(this.state.followers - 1));
        this.setState({ follow: !this.state.follow, followers: this.state.followers - 1 });
      });
    }
  }

  updateFollowStatus = (addCompanyFollower = false) => {
    axios.get(`/api/companies/${this.props.companyId}/following`, { cancelToken: this.source.token })
    .then((res) => {
      if (res.status === 204) {
        this.setState({ follow: false });
      } else {
        if (addCompanyFollower && this.state.follow !== true) {
          this.props.dispatch(updateCompanyFollowers(this.state.followers + 1));
          this.setState({ follow: true, followers: this.state.followers + 1 });
        } else {
          this.setState({ follow: true });
        }
      }
    })
    .catch((err) => {
      this.setState({ follow: false });
    });
  }

  isCompanyMember = () => {
    return Boolean(this.props.companyMembers && Object.values(this.props.companyMembers)
      .find((el: ITeamMember) => el.profile_id === this.props.profile_id));
  }

  getUnFollowText = (isCreator: boolean, isOwner: boolean, isCompanyMember: boolean) => {
    const role = isCreator ? 'the creator' : isOwner ? 'the owner' : 'a member';
    if (isCreator || isOwner || isCompanyMember) {
      return `Are you sure you want to unfollow? As you are ${role} of this company, we
      recommend you to follow it to keep engaged with your investors.`;
    }

    return 'Unfollowing disables all notifications about this company.';
  }

  render() {
    const { follow } = this.state;
    const className = follow ? style.followedBtn : style.followBtn;
    const isCompanyMember = this.isCompanyMember();

    return (
      <div className={style.followCompany}>
        <h3>{this.props.name}</h3>
        <p>{`${this.state.followers} ${this.state.followers === 1 ? 'Follower' : 'Followers'}`}</p>
        {follow !== null && this.props.userSignedIn &&
          <ToolTip
            text={follow
              ? this.getUnFollowText(this.props.isCreator, this.props.isOwner, isCompanyMember)
              : 'Receive notifications about this company.'
            }
            className={style.followTooltip}
          >
            <button className={className} onClick={this.btnOnClick}>
              {follow ? 'Following' : 'Follow'}
            </button>
          </ToolTip>
        }
      </div>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    companyMembers: store.companyReducer.companyMembers,
    profile_id: store.userInfo.profile_id,
  };
};

export default connect(mapStateToProps)(FollowCompany);

export const updateFollowStatus = () => {
  componentRef ? componentRef.updateFollowStatus(true) : null;
};
